import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import router from '@/router'

@Module({ namespaced: true })
class GlobalValues extends VuexModule {
  public isLoading?: boolean = false
  public notificationMessage?: string = undefined

  @Mutation
  public updateLoading (newVal: boolean): void {
    this.isLoading = newVal
  }

  @Action
  public setLoading (newVal: boolean): void {
    this.context.commit('updateLoading', newVal)
  }

  @Mutation
  public updateNotification (message?: string): void {
    this.notificationMessage = message
  }

  @Action
  public setNotification (message?: string): void {
    this.context.commit('updateNotification', message)
  }

  @Action
  public showAllDesigns (): void {
    router.push({ path: router.currentRoute.path, query: { ...router.currentRoute.query, modal: 'designs' } })
  }

  @Action
  public showInspirationIdeas (): void {
    router.push({ path: router.currentRoute.path, query: { ...router.currentRoute.query, modal: 'inspirations' } })
  }

  @Action
  public hidePopover (): void {
    router.replace({ path: router.currentRoute.path, query: { ...router.currentRoute.query, modal: undefined } })
  }
}
export default GlobalValues
